module.exports = __webpack_public_path__ + "static/media/_LOGO_MOB.6040b431.svg";